module.exports = __webpack_public_path__ + "static/media/AwsDoc3.fbe591e0.png";